const { renderWishlist } =
  await import(`./render-wishlist.js?v=${Date.now()}`);
import "./index.js";
import "./_commonjsHelpers.js";
import "./recommended-products.js";
import "./pricing.js";
class WishlistButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector(".js-fav");
    const grid = document.querySelector(".wishlist__grid");
    const handleFavButton = () => {
      const currentStorage = localStorage.getItem("Suite702_wishlist");
      if (currentStorage) {
        const productsArray = JSON.parse(currentStorage);
        productsArray == null ? void 0 : productsArray.forEach((product) => {
          if (product.id === button.dataset.productId) {
            button.classList.add("is-active");
          } else {
            button.classList.remove("is-active");
          }
        });
      } else {
        button.classList.remove("is-active");
      }
    };
    const inWishList = (productId) => {
      const storageArray = localStorage.getItem("Suite702_wishlist");
      const productsArray = JSON.parse(storageArray);
      let state = false;
      productsArray.forEach((product) => {
        product.id === productId ? state = true : null;
      });
      return state;
    };
    const addToWishlist = (parsedArray, productId, productHandle) => {
      parsedArray.push({ id: productId, handle: productHandle });
      localStorage.setItem("Suite702_wishlist", JSON.stringify(parsedArray));
      handleFavButton();
      handleCounterItem(JSON.parse(localStorage.getItem("Suite702_wishlist")).length);
    };
    const removeFromWishlist = (parsedArray, productId) => {
      const data = parsedArray.filter((product) => product.id !== productId);
      localStorage.setItem("Suite702_wishlist", JSON.stringify(data));
      data.length === 0 ? localStorage.removeItem("Suite702_wishlist") : null;
      handleFavButton();
      handleCounterItem(data.length);
      if (grid) {
        const wishlist = JSON.parse(localStorage.getItem("Suite702_wishlist"));
        renderWishlist(wishlist, grid);
      }
    };
    const handleCounterItem = (amount) => {
      const counter = document.querySelector(".js-counter");
      if (amount > 0) {
        counter.classList.add("js-counter--active");
        counter.innerHTML = amount;
      } else {
        counter.classList.remove("js-counter--active");
        counter.innerHTML = "";
      }
    };
    if (button) {
      handleFavButton();
      button.addEventListener("click", (e) => {
        e.preventDefault();
        console.log("click");
        const item = localStorage.getItem("Suite702_wishlist");
        button.classList.toggle("toggle-animation");
        if (item) {
          const productId = button.dataset.productId ? button.dataset.productId : null;
          const productHandle = button.dataset.productHandle ? button.dataset.productHandle : null;
          const parsedArray = JSON.parse(item);
          inWishList(productId) ? removeFromWishlist(parsedArray, productId) : addToWishlist(parsedArray, productId, productHandle);
        } else {
          const productId = button.dataset.productId ? button.dataset.productId : null;
          const productHandle = button.dataset.productHandle ? button.dataset.productHandle : null;
          localStorage.setItem("Suite702_wishlist", JSON.stringify([
            {
              id: productId,
              handle: productHandle
            }
          ]));
          handleFavButton();
          handleCounterItem(JSON.parse(localStorage.getItem("Suite702_wishlist")).length);
        }
      });
    }
  }
}
if (customElements.get("wishlist-button") === void 0) {
  customElements.define("wishlist-button", WishlistButton);
}
